export const FONT_FAMILY_OPTIONS = [
  { label: 'Default', value: '' },
  { label: 'Vag', value: 'Vag' },
  { label: 'Vag Regular', value: 'vag-regular' },
  { label: 'Vag Bold', value: 'Vag-Bold' },
  { label: 'Kohinoor Devanagari', value: 'Kohinoor Devanagari' },
  { label: 'Noto Sans Devanagari', value: 'Noto Sans Devanagari' },
  { label: 'Mukta', value: 'Mukta' },
  { label: 'Serif', value: 'serif' },
  { label: 'Sans', value: 'sans-serif' },
  { label: 'Monospace', value: 'monospace' },
];

export const BORDER_STYLE_OPTIONS = [
  { label: 'None', value: 'none' },
  { label: 'Solid', value: 'solid' },
  { label: 'Dashed', value: 'dashed' },
  { label: 'Dotted', value: 'dotted' },
  { label: 'Double', value: 'double' },
];

export const SPAN_OPTIONS = [
  { label: 'Full', value: 24 },
  { label: 'Half', value: 12 },
];

export const LINE_HEIGHT_OPTIONS = [
  { label: '1.0', value: 1 },
  { label: '1.15', value: 1.15 },
  { label: '1.5', value: 1.5 },
  { label: '2.0', value: 2 },
];

export const WIDTH_PERCENT_OPTIONS = [
  { label: 'Auto', value: 0 },
  { label: '25%', value: 25 },
  { label: '50%', value: 50 },
  { label: '75%', value: 75 },
  { label: '100%', value: 100 },
];

export const DISPLAY_OPTIONS = [
  { label: 'Auto', value: '' },
  { label: 'Block', value: 'block' },
  { label: 'Inline', value: 'inline' },
  { label: 'In-line block', value: 'inline-block' },
];
